import { Api } from '@axiom/ui';

import LegacyApiHelper from '../classes/legacy-api-helper';
import { EnvUtil } from '../utils/env-util';

/**
 * This is displayed to user so needs to be talent, not candidate
 */
const api = new LegacyApiHelper('opportunity talent');

export const getCandidatesByJobId = async opportunityId => {
  const response = await api.GET(`/opportunities/${opportunityId}/candidates`);
  return { data: response.data };
};

export const postTalentsByOpportunityID = async ({
  opportunityId,
  candidateIds,
}) => {
  const { data } = await api.POST(
    `/opportunities/${opportunityId}/candidates`,
    {
      candidateIds: [...candidateIds],
    }
  );
  return { data };
};

export const updateOpportunityCandidate = async (opportunityId, candidate) => {
  const { data } = await api.PATCH(
    `/opportunities/${opportunityId}/candidates/${candidate.id}`,
    candidate
  );
  return { data };
};

class OpportunityTalentApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  createOpportunityCandidates({ opportunityId, candidateIds }) {
    return super.write({
      endpoint: `/opportunities/${opportunityId}/candidates`,
      method: 'POST',
      body: { candidateIds: [...candidateIds] },
    });
  }
}

export const OpportunityTalentApi = new OpportunityTalentApiClass();

export const updateTalentStatusByOpportunity = async ({
  opportunityId,
  candidateId,
  candidateStatus,
  candidateStatusMessage,
}) => {
  const payload = {
    candidateStatus,
    candidateStatusMessage,
  };
  const { data } = await api.PATCH(
    `/opportunities/${opportunityId}/candidates/${candidateId}`,
    payload
  );
  return { data };
};
